import type { ReactNode } from 'react';

/**
 * Hero headline estilo medicus.com.ar: TODO MAYÚSCULAS + ExtraBold +
 * parte de la frase en celeste acento.
 *
 * Uso:
 *   <HeroHeading>EXPERTOS EN LO QUE <HeroHeading.HL>TE HACE BIEN</HeroHeading.HL></HeroHeading>
 *
 * El texto se transforma en uppercase via CSS, así que se puede pasar en
 * cualquier case y queda consistente.
 */
export function HeroHeading({
  children,
  as: Tag = 'h1',
  className,
  style,
}: {
  children: ReactNode;
  /** Etiqueta semántica — usar h1 en hero, h2 en secciones */
  as?: 'h1' | 'h2' | 'h3';
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <Tag className={`heading-hero ${className ?? ''}`.trim()} style={style}>
      {children}
    </Tag>
  );
}

/** Parte de la frase iluminada en celeste acento. */
function HeroHeadingHL({ children }: { children: ReactNode }) {
  return <span className="heading-hero__hl">{children}</span>;
}

HeroHeading.HL = HeroHeadingHL;
